import { Container, styled } from "@mui/material";
import { OneTimePassword } from "./one-time-password";
import { MagicLink } from "./magic-link";
import { Error } from "./error";
import { LoginProvider } from "./context";
import { SelectAccount } from "./select-account";

export const Login = () => {
  return (
    <LoginProvider>
      <LoginContainer style={{maxWidth: "1024px"}}>
            <MagicLink />
            <OneTimePassword />
            <SelectAccount />
            <Error />
      </LoginContainer>
    </LoginProvider>
  );
};

export const LoginContainer = styled(Container)({
  marginTop: "24px"
});
